// extracted by mini-css-extract-plugin
export var alertIcon = "_qf-0";